// extracted by mini-css-extract-plugin
module.exports = {"entitiesLayout":"mKvBA"};